@if ((loadedState$ | async); as loadedState) {
  <div>
    <ng-container class="report-container">
      @switch (loadedState) {
        @case (LoadingState.LOADING) {
          <ngx-zero-state class="loading-indicator-zero-state ng-animate-disabled">
            <p zero-state-title><span translate="activity-view_reports-loading-indicator-title"></span></p>
            <p zero-state-subtext><span translate="activity-view_sessions-loading-indicator-subtext"></span></p>
            <p zero-state-body><span class="loading-indicator-icon ficon-spinner ficon-spin"></span></p>
          </ngx-zero-state>
        }
        @case (LoadingState.ERROR) {
          <ngx-zero-state class="error-zero-state">
            <p zero-state-title><span translate="activity-report-panel_activity-report-unavailable"></span></p>
          </ngx-zero-state>
        }
        @case (LoadingState.LOADED) {
          <section class="course-report">
            <div
              [attr.aria-label]="'activity-report_table-aria-label' | translate"
              class="table-wrapper">
              <table
                #table
                mat-table
                [dataSource]="datasource$ | async"
                multiTemplateDataRows
                class="course-report-table fixed-layout">
                <ng-container matColumnDef="expander">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                  </th>
                  <td mat-cell *matCellDef="let u">
                    <button
                      type="button"
                      class="expander-btn"
                      [attr.aria-label]="('activity-report_toggle-row' | translate: {firstName: u.first_name, lastName: u.last_name})"
                      [attr.aria-expanded]="expandedIds.has(u.user_id)"
                      [attr.aria-controls]="'detail-row-' + u.user_id"
                      (click)="toggleRow(u.user_id); $event.stopPropagation();"
                      (keydown.enter)="$event.stopPropagation()">
                      <i class="ficon-app-chevron-down chev"
                        [class.open]="expandedIds.has(u.user_id)"
                      aria-hidden="true"></i>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef class="left" translate="common_user"></th>
                  <td mat-cell *matCellDef="let u" class="left">
                    <span class="user-name">{{ u.first_name }} {{ u.last_name }}</span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef translate="modal-edit-user_role"></th>
                  <td mat-cell *matCellDef="let u">{{ u.role | titlecase }}</td>
                </ng-container>
                <ng-container matColumnDef="videosPresented">
                  <th mat-header-cell *matHeaderCellDef
                  translate="activity-report_videos-presented-column-header"></th>
                  <td mat-cell *matCellDef="let u">{{ u.num_videos_presented }}</td>
                </ng-container>
                <ng-container matColumnDef="videosReviewed">
                  <th mat-header-cell *matHeaderCellDef
                  translate="activity-report_videos-critiqued-column-header"></th>
                  <td mat-cell *matCellDef="let u">{{ u.num_videos_reviewed }}</td>
                </ng-container>
                <ng-container matColumnDef="commentsWritten">
                  <th mat-header-cell *matHeaderCellDef
                  translate="activity-report_comments-written-column-header"></th>
                  <td mat-cell *matCellDef="let u">{{ u.num_comments }}</td>
                </ng-container>
                <ng-container matColumnDef="avgCommentLen">
                  <th mat-header-cell *matHeaderCellDef
                  translate="activity-report_controller-avg-comment-length"></th>
                  <td mat-cell *matCellDef="let u">{{ dashIfNull(u.avg_comment_length) }}</td>
                </ng-container>
                <ng-container matColumnDef="markers">
                  <th mat-header-cell *matHeaderCellDef translate="library-collections_add-markers"></th>
                  <td mat-cell *matCellDef="let u">
                    @if (u.marker_counts.length > 0) {
                      <button
                        type="button"
                        class="linklike-btn"
                        [goCdkPopover]="markersTemplate"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
                        goCdkPopoverMaxHeight="300"
                        goCdkPopoverTrigger="click"
                        goCdkPopoverPosition="below"
                        goCdkPopoverBgColor="#fff"
                        goCdkPopoverShowArrow="true"
                        goCdkPopoverShadow="true"
                        [attr.aria-label]="('activity-report_open-markers-for-user' | translate: {firstName: u.first_name, lastName: u.last_name})">
                        {{ sumMarkerCounts(u.marker_counts) }}
                      </button>
                    } @else {
                      <span>
                        {{ u.marker_counts.length }}
                      </span>
                    }
                    <ng-template #markersTemplate>
                      <div>
                        <marker-display
                          [markers]="u.transformedMarkers"
                          [withCount]="true"
                          [withName]="true"
                          [verticalLayout]="true">
                        </marker-display>
                      </div>
                    </ng-template>
                  </td>
                </ng-container>
                <ng-container matColumnDef="avgScore">
                  <th mat-header-cell *matHeaderCellDef translate="activity-report_score-avg-column-header"></th>
                  <td mat-cell *matCellDef="let u">{{ u.score != null ? (u.score | number:'1.2-2') : '-' }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <!-- Parent Row -->
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  class="user-row"
                  [class.expanded]="expandedIds.has(row.user_id) && lastExpandedRow === row.user_id"
                  [attr.aria-expanded]="expandedIds.has(row.user_id)"
                  [attr.aria-controls]="'detail-row-' + row.user_id"
                  data-cy="activity-report-expand-user"
                  (click)="toggleRow(row.user_id)">
                </tr>
                <ng-container matColumnDef="expandedDetail">
                  <td
                    mat-cell
                    *matCellDef="let u"
                    [attr.id]="'detail-row-' + u.user_id"
                    [attr.colspan]="displayedColumns.length"
                    class="detail-cell">
                    @if ((rowLoadingIds$ | async); as loadingSet) {
                      @if (isRowLoading(u.user_id, loadingSet)) {
                        <div class="detail-center"
                          >
                          <span class="loading-indicator-icon ficon-spinner ficon-spin"
                          [attr.aria-label]="'common_loading' | translate"></span>
                        </div>
                      } @else {
                        @if (userReport$(u.user_id) | async; as sessions) {
                          @if (sessions.length === 0) {
                            <div class="detail-center">
                              <p class="no-sessions-message" role="status"
                                translate="activity-report_controller-no-sessions-to-show">
                              </p>
                            </div>
                          } @else {
                            <table class="detail-native" role="presentation" aria-hidden="false">
                              <colgroup>
                              <col class="col-spacer"/>
                              <col class="col-engagement"/>
                              <col class="col-comments"/>
                              <col class="col-markers"/>
                            </colgroup>
                            <thead>
                              <tr>
                                <th class="col-spacer" aria-hidden="true"></th>
                                <th scope="col" class="col-engagement"
                                translate="activity-report_video-engagement-column-header"></th>
                                <th scope="col" class="col-comments"
                                translate="comments"></th>
                                <th scope="col" class="col-markers"
                                translate="library-collections_add-markers"></th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (s of sessions; track s) {
                                <tr class="detail-row-tr">
                                  <!-- spacer to align under expander column -->
                                  <td class="col-spacer" aria-hidden="true"></td>
                                  <td class="col-engagement">
                                    <div class="engagement-stack">
                                      <div class="line title">
                                        <span
                                        translate="activity-report_video-name-label"></span>: {{ s.description || ('activity-report_default-session-name' | translate) }}
                                      </div>
                                      <div class="line person">
                                        <span
                                        translate="activity-report_participants-label"></span>:
                                        @for (p of s.presenters; track p) {
                                          <div>{{ p.first_name }} {{ p.last_name }}</div>
                                        }
                                      </div>
                                      <div class="line score">
                                        <span
                                        translate="common_score"></span>: {{ s.total_score == null ? '-' : s.total_score }}
                                      </div>
                                    </div>
                                  </td>
                                  <td class="col-comments">
                                    <ul class="comments-list">
                                      @for (c of commentsAsc(s); track c) {
                                        <li>
                                          <span class="comment-time">
                                            {{ c.time == null ? '—' : (c.time | formatTime) }}
                                          </span>
                                        </li>
                                      }
                                    </ul>
                                  </td>
                                  <td class="col-markers">
                                    @if (s.marker_counts.length > 0) {
                                      <button
                                        type="button"
                                        class="linklike-btn"
                                        [goCdkPopover]="markersTemplateDetail"
                                        (click)="$event.stopPropagation()"
                                        (keydown.enter)="$event.stopPropagation()"
                                        (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
                                        goCdkPopoverMaxHeight="300"
                                        goCdkPopoverTrigger="click"
                                        goCdkPopoverPosition="below"
                                        goCdkPopoverBgColor="#fff"
                                        goCdkPopoverShowArrow="true"
                                        goCdkPopoverShadow="true"
                                        [attr.aria-label]="('activity-report_open-markers-for-user' | translate: {firstName: u.first_name, lastName: u.last_name})">
                                        {{ sumMarkerCounts(s.marker_counts) }}
                                      </button>
                                    } @else {
                                      <span>
                                        {{ s.marker_counts.length }}
                                      </span>
                                    }
                                    <ng-template #markersTemplateDetail>
                                      <div>
                                        <marker-display
                                          [markers]="s.transformedMarkers"
                                          [withCount]="true"
                                          [withName]="true"
                                          [verticalLayout]="true">
                                        </marker-display>
                                      </div>
                                    </ng-template>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        }
                      }
                    }
                  }
                </td>
              </ng-container>
              <tr mat-row
                *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow"
                class="detail-row">
              </tr>
            </table>
          </div>
        </section>
      }
    }
  </ng-container>
</div>
}
